import React from 'react';
import PropTypes from 'prop-types';

import '@/styles/buttonStyle.less';

const Button = ({ 
  children, 
  variant = 'primary', 
  icon: Icon = null,
  iconOnly = false,
  iconSize = 'md',
  iconColor = 'white',
  className = '',
  marginClassName = '!mt-2',
  ...props 
}) => {
  const baseStyles = "";
  
  const variants = {
    primary: `
      btn-primary
      h-14
      px-3
      font-bold
      transition-colors
      w-full
      ${marginClassName}
    `,
    secondary: `
      btn-secondary
      w-1/2
      items-start
      justify-start
      ${marginClassName}
    `,
    icon: `
      btn-icon
      w-1/2
      items-start
      justify-start
      ${marginClassName}
    `,
    simple: `
      btn-simple
      w-1/2
      items-start
      justify-start
      ${marginClassName}
    `,
    balance: `
      btn-balance
      w-full
      items-start
      justify-start
      ${marginClassName}
    `,
      outlined: `
      btn-outlined
      h-14
      px-6
      font-bold
      transition-colors
      ${marginClassName}
    `,
    link: `
      btn-link
  `,
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {Icon && <Icon className={`${children ? 'mr-2' : ''} w-6 h-6`} />}
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['primary', 'secondary', 'balance', 'simple', 'icon']),
  icon: PropTypes.elementType,
  iconOnly: PropTypes.bool,
  iconSize: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
};

export default Button;
